module.exports = __webpack_public_path__ + "img/f3-d.1bae7be7.png";